import React from "react";
import { HeaderFooter } from "../core/pdf/types";
import { useDesigner } from "./useDesigner";
import { ElementContext, useElementContext } from "./useElementContext";
import { useContentState } from "./useContentState";
import { toMillimeters } from "../core/pdf/utils";
import { closestKey } from "../core/utils/dom";
import { ContentItems } from "./ContentItems";
import { ElementTag } from "./ElementTag";


export function HeaderFooterEditor(props: {
	type: "header" | "footer",
	headerFooter: HeaderFooter,
}) {
	const designer = useDesigner();

	const elementContext = useElementContext(props.headerFooter);

	const state = useContentState(elementContext, React.useCallback((msg: any) => {

	}, []));

	const style = {
		// position: "absolute",
		// left: toMillimeters(designer.structure.defaults.margin.left) + "mm",
		// right: toMillimeters(designer.structure.defaults.margin.right) + "mm",
		height: toMillimeters(props.headerFooter.height) + "mm",
	} as any;

	// if (props.type === "header") {
	// 	style.top = toMillimeters(designer.structure.defaults.margin.top) + "mm";	
	// } else {
	// 	style.bottom = toMillimeters(designer.structure.defaults.margin.bottom) + "mm";	
	// }

	return (
		<ElementContext.Provider value={elementContext}>
			<div
				className={props.type + " content-element " + state.classes}
				data-key={props.headerFooter.id}
				id={state.elementID}
				style={style as any}

				onClick={(e) => {
					const key = closestKey(e.target, ".content-element");
					if (key) {
						const ref = designer.getRef(Number(key));
						if (ref) {
							designer.setFocus(ref);
						}
					// } else {
					// 	// clicked out of area, so remove focus entirely
					// 	if (designer.focus) designer.setFocus(undefined);
					}
				}}
			>
				<ElementTag />
				<ContentItems
					content={props.headerFooter.content}
				/>
			</div>
		</ElementContext.Provider>
	);
}
